export default "__VITE_ASSET__CNSJ8Bpj__"